import { PortalModule } from '@angular/cdk/portal';
import { utf8Encode } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../app.service';
import { UCInflection_CAT_WornLimitsVM, UCLinear_LIEBHERR_WornLimitsVM, UCPolynomial_KOMATSU_WornLimitsVM, UCStepped_ITM_WornLimitsVM, UCWornLimitGenericIdNameVM } from './uc-setup-worn-limit.module';
import { UcSetupWornLimitService } from './uc-setup-worn-limit.service';

@Component({
  selector: 'app-setup-worn-limit',
  templateUrl: './setup-worn-limit.component.html',
  styleUrls: ['./setup-worn-limit.component.scss']
})
export class SetupWornLimitComponent implements OnInit {

  ShowHideMethodOfCal: boolean = false;
  ShowHideInflection: boolean = false;
  ShowHideStepped: boolean = false;
  ShowHidePolynomial: boolean = false;

  labelModel: string = "";
  labelPart: string = "";
  labelMake: string = "";
  selectedModel: number;
  selectedMake: number;
  selectedCompType: number;
  selectedComponent: number;
  selectedToolUsed: number;
  selectedPart: number;
  selectedMethod: number;
  selectedTool: number;
  MIYIntercept2: number;
  HIYIntercept2: number;
  MISlope2: number;
  HISlope2: number;
  MIYIntercept1: number;
  HIYIntercept1: number;
  MISlope1: number;
  HISlope1: number;
  MIInflectionPoint: number;
  HIInflectionPoint: number;
  Slope: number;
  AdjustmentToBase: number;

  ImpactStartDepthNew: number;
  NormalStartDepthNew: number;
  Impact10WearDepth: number;
  Impact70WearDepth: number;
  Impact20WearDepth: number;
  Impact80WearDepth: number;
  Impact30WearDepth: number;
  Impact90WearDepth: number;
  Impact40WearDepth: number;
  Impact100WearDepth: number;
  Impact50WearDepth: number;
  Impact110WearDepth: number;
  Impact60WearDepth: number;
  Impact120WearDepth: number;
  Normal10WearDepth: number;
  Normal70WearDepth: number;
  Normal20WearDepth: number;
  Normal80WearDepth: number;
  Normal30WearDepth: number;
  Normal90WearDepth: number;
  Normal40WearDepth: number;
  Normal100WearDepth: number;
  Normal50WearDepth: number;
  Normal110WearDepth: number;
  Normal60WearDepth: number;
  Normal120WearDepth: number;

  PolynomialImpact2ndOrder: number;
  PolynomialImpactSlope: number;
  PolynomialImpactIntercept: number;
  PolynomialNormal2ndOrder: number;
  PolynomialNormalSlope: number;
  PolynomialNormalIntercept: number;

  LinearNormalIntercept: number;
  LinearNormalSlope: number;
  LinearImpactIntercept: number;
  LinearImpactSlope: number;

  startingDim: number;
  _100perceDim: number;

  ToolList: UCWornLimitGenericIdNameVM[] = [];
  ModelList: UCWornLimitGenericIdNameVM[] = [];
  MakeList: UCWornLimitGenericIdNameVM[] = [];
  CompTypeList: UCWornLimitGenericIdNameVM[] = [];
  ComponentList: UCWornLimitGenericIdNameVM[] = [];
  CopyComponentList: UCWornLimitGenericIdNameVM[] = [];

  ToolUsedList: UCWornLimitGenericIdNameVM[] = [];
  PartList: UCWornLimitGenericIdNameVM[] = [];
  MethodList: UCWornLimitGenericIdNameVM[] = [];


  SteppedData: UCStepped_ITM_WornLimitsVM[]
  InflectionData: UCInflection_CAT_WornLimitsVM[]
  PolynomialData: UCPolynomial_KOMATSU_WornLimitsVM[]
  LinearData: UCLinear_LIEBHERR_WornLimitsVM[]


  Info_SteppedData: UCStepped_ITM_WornLimitsVM
  Info_InflectionData: UCInflection_CAT_WornLimitsVM
  Info_PolynomialData: UCPolynomial_KOMATSU_WornLimitsVM
  Info_LinearData: UCLinear_LIEBHERR_WornLimitsVM

  MakeName: string;
  ComprtType: string;
  Component: string;
  PartNo: string;
  MethodName: string;
  constructor(
    private _limitService: UcSetupWornLimitService, private _appService: AppService,
    private _notification: NotificationsService,private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Undercarriage Worn Limit Management');

    this.selectedPart = +this.route.snapshot.paramMap.get('id');
    this.selectedComponent = +this.route.snapshot.paramMap.get('id');

    this.selectedTool = +this.route.snapshot.paramMap.get('id2');
    
    this.LoadMake();
    this.LoadModel();
    this.LoadTrackTools();
    this.LoadCompartType();
    this.LoadComparts();
    this.LoadCalculationMethods();

    if(this.selectedPart>0 && this.selectedTool>0){
      this.onClickSearch();
    }

  }


  LoadMake() {
    this._limitService.GETUCWornLimitMakes().subscribe(res => {
      this.MakeList = res;
    })
  }

  LoadModel() {
    this._limitService.GETUCWornLimitModels().subscribe(res => {
      this.ModelList = res;
    })
  }

  LoadCompartType() {
    this._limitService.GETUCWornLimitCompartTypes().subscribe(res => {
      this.CompTypeList = res;

    })
  }

  LoadComparts() {
    this._limitService.GETUCWornLimitComparts().subscribe(res => {
      this.ComponentList = res;
      this.CopyComponentList = res;
      this.PartList = res;
    })
  }

  LoadTrackTools() {
    this._limitService.GETUCWornLimitTrackTools().subscribe(res => {
      this.ToolList = res;
    })
  }

  LoadCalculationMethods() {
    this._limitService.GETUCWornLimitCalcMethods().subscribe(res => {
      this.MethodList = res;
    })
  }



  onClickReset() {
    this.selectedMake = null;
    this.selectedModel = null;
    this.selectedCompType = null;
    this.selectedComponent = null;
    this.selectedPart = null;
    this.selectedTool = null;
    this.selectedMethod = null;
    this.SteppedData = [];
    this.InflectionData = [];
    this.PolynomialData = [];
    this.LinearData = [];
    
  }


  onClickSearch() {

    // this.labelMake = this.MakeList.find(f => f.Id == this.selectedMake).Desc
    // this.labelModel = this.ModelList.find(f => f.Id == this.selectedModel).Desc
    // this.labelPart = this.PartList.find(f => f.Id == this.selectedPart).Desc

    this.loadCompartUCWornLImitInfo();

  }

  loadCompartUCWornLImitInfo() {
    this.selectedTool = this.selectedTool > 0 ? this.selectedTool : 0;
    console.log("data_", this.selectedPart, this.selectedTool)
    this._limitService.GetCompartUCWornLimitData(this.selectedPart, this.selectedTool).subscribe(res => {
      this.selectedMethod = res.Method;
      this.SteppedData = res.SteppedData;
      this.InflectionData = res.InflectionData;
      this.PolynomialData = res.PolynomialData;
      this.LinearData = res.LinearData;
      this.MakeName = res.MakeName;
      this.Component = res.Component;
      this.ComprtType = res.ComprtType;
      this.PartNo = res.PartNo;
      this.MethodName = res.MethodName;
      this.labelPart = res.PartNo;
      this.labelMake = res.MakeName;
      console.log("result__", res)
    })

  }


  InflectionRowClick(item: UCInflection_CAT_WornLimitsVM) {
    this.Info_InflectionData = item;
    this.MIYIntercept2 = item.mi_Intercept_2
    this.HIYIntercept2 = item.hi_Intercept_2
    this.MISlope2 = item.mi_Slope_2
    this.HISlope2 = item.hi_Slope_2
    this.MIYIntercept1 = item.mi_Intercept_1;
    this.HIYIntercept1 = item.hi_Intercept_1
    this.MISlope1 = item.mi_Slope_1
    this.HISlope1 = item.hi_Slope_1
    this.MIInflectionPoint = item.mi_InflectionPoint
    this.HIInflectionPoint = item.hi_InflectionPoint
    this.Slope = item.Slope;
    this.AdjustmentToBase = item.adjust_base
    this._100perceDim = item.Worn_100
    this.startingDim = item.Starting_Dim;
    this.selectedTool = item.toolId;
  }


  SteppedRowClick(item: UCStepped_ITM_WornLimitsVM) {

    this.Info_SteppedData = item;
    this._100perceDim = item.Worn_100
    this.startingDim = item.Starting_Dim;
    this.selectedTool = item.toolId;
    this.Impact10WearDepth = item.wearDepth_10;
    this.Impact20WearDepth = item.wearDepth_20;
    this.Impact30WearDepth = item.wearDepth_30;
    this.Impact40WearDepth = item.wearDepth_40;
    this.Impact50WearDepth = item.wearDepth_50;
    this.Impact60WearDepth = item.wearDepth_60;
    this.Impact70WearDepth = item.wearDepth_70;
    this.Impact80WearDepth = item.wearDepth_80;
    this.Impact90WearDepth = item.wearDepth_90;
    this.Impact100WearDepth = item.wearDepth_100;
    this.Impact110WearDepth = item.wearDepth_110;
    this.Impact120WearDepth = item.wearDepth_120;
    this.ImpactStartDepthNew = item.startDepeth_New;
    this.NormalStartDepthNew = item.startDepeth_Mi;
    this.Normal10WearDepth = item.wearDepth_10_Mi;
    this.Normal20WearDepth = item.wearDepth_20_Mi;
    this.Normal30WearDepth = item.wearDepth_30_Mi;
    this.Normal40WearDepth = item.wearDepth_40_Mi;
    this.Normal50WearDepth = item.wearDepth_50_Mi;
    this.Normal60WearDepth = item.wearDepth_60_Mi;
    this.Normal70WearDepth = item.wearDepth_70_Mi;
    this.Normal80WearDepth = item.wearDepth_80_Mi;
    this.Normal90WearDepth = item.wearDepth_90_Mi;
    this.Normal100WearDepth = item.wearDepth_100_Mi;
    this.Normal110WearDepth = item.wearDepth_110_Mi;
    this.Normal120WearDepth = item.wearDepth_120_Mi;
  }
  LinearRowClick(item: UCLinear_LIEBHERR_WornLimitsVM) {

    this.Info_LinearData = item;
    this.selectedTool = item.toolId;
    this.LinearImpactSlope = item.impact_slope;
    this.LinearImpactIntercept = item.impact_intercept;
    this.LinearNormalSlope = item.normal_slope;
    this.LinearNormalIntercept = item.normal_intercept;
    this._100perceDim = item.Worn_100
    this.startingDim = item.Starting_Dim;
  }
  PolynomialRowClick(item:UCPolynomial_KOMATSU_WornLimitsVM){
    this.Info_PolynomialData = item;
    this.selectedTool = item.toolId;
    this._100perceDim = item.Worn_100
    this.startingDim = item.Starting_Dim;

    this.PolynomialImpact2ndOrder = item.impact_secondOrder;
    this.PolynomialImpactIntercept=item.impact_intercept;
    this.PolynomialImpactSlope=item.impact_slope;

    this.PolynomialNormal2ndOrder=item.normal_secondOrder;
    this.PolynomialNormalIntercept=item.normal_intercept;
    this.PolynomialNormalSlope=item.normal_slope;

  }

  changeMake() {
    this.labelMake = this.MakeList.find(f => f.Id == this.selectedMake).Desc;
  }
  changeModel() {

  }

  changePart() {
    this.selectedComponent = this.selectedPart;
  }
  changeCompart() {
    this.selectedPart = this.selectedComponent;
  }

  changeCompType() {
    this.ComponentList = this.CopyComponentList;
    if (this.selectedCompType > 0) {
      this.ComponentList = this.ComponentList.filter(x => x.CompTypeId == this.selectedCompType);
    }
  }

  AddWornLimits() {
    if (this.selectedMethod == 1)//Stepped
    {
      var model = new UCStepped_ITM_WornLimitsVM();
      model.CompartId = this.selectedPart;
      model.Worn_100 = this._100perceDim
      model.Starting_Dim = this.startingDim
      model.toolId = this.selectedTool
      model.wearDepth_10 = this.Impact10WearDepth
      model.wearDepth_20 = this.Impact20WearDepth
      model.wearDepth_30 = this.Impact30WearDepth
      model.wearDepth_40 = this.Impact40WearDepth
      model.wearDepth_50 = this.Impact50WearDepth
      model.wearDepth_60 = this.Impact60WearDepth
      model.wearDepth_70 = this.Impact70WearDepth
      model.wearDepth_80 = this.Impact80WearDepth
      model.wearDepth_90 = this.Impact90WearDepth
      model.wearDepth_100 = this.Impact100WearDepth
      model.wearDepth_110 = this.Impact110WearDepth
      model.wearDepth_120 = this.Impact120WearDepth
      model.startDepeth_New = this.ImpactStartDepthNew
      model.startDepeth_Mi = this.NormalStartDepthNew
      model.wearDepth_10_Mi = this.Normal10WearDepth
      model.wearDepth_20_Mi = this.Normal20WearDepth
      model.wearDepth_30_Mi = this.Normal30WearDepth
      model.wearDepth_40_Mi = this.Normal40WearDepth
      model.wearDepth_50_Mi = this.Normal50WearDepth
      model.wearDepth_60_Mi = this.Normal60WearDepth
      model.wearDepth_70_Mi = this.Normal70WearDepth
      model.wearDepth_80_Mi = this.Normal80WearDepth
      model.wearDepth_90_Mi = this.Normal90WearDepth
      model.wearDepth_100_Mi = this.Normal100WearDepth
      model.wearDepth_110_Mi = this.Normal110WearDepth
      model.wearDepth_120_Mi = this.Normal120WearDepth
      

      this._limitService.AddNewSteppedWornLimit(model).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully add new worn limit")
        } else {
          this._notification.error("Failed, Unabled to add new worn limit")
        }
      })
    }

    if (this.selectedMethod == 2)//Inflection
    {
      var infModel = new UCInflection_CAT_WornLimitsVM();
      infModel.mi_Intercept_2 = this.MIYIntercept2
      infModel.hi_Intercept_1 = this.HIYIntercept1
      infModel.mi_Slope_1 = this.MISlope1
      infModel.hi_Slope_2 = this.HISlope2
      infModel.mi_Intercept_1 = this.MIYIntercept1
      infModel.hi_Intercept_2 = this.HIYIntercept2
      infModel.mi_Slope_2 = this.MISlope2
      infModel.hi_Slope_1 = this.HISlope1
      infModel.mi_InflectionPoint = this.MIInflectionPoint
      infModel.hi_InflectionPoint = this.HIInflectionPoint
      infModel.Slope = this.Slope
      infModel.adjust_base = this.AdjustmentToBase
      infModel.Worn_100 = this._100perceDim
      infModel.Starting_Dim = this.startingDim
      infModel.toolId = this.selectedTool
      infModel.CompartId = this.selectedPart;

      this._limitService.AddNewInflectionWornLimit(infModel).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully add new worn limit")
        } else {
          this._notification.error("Failed, Unabled to add new worn limit")
        }
      })
    }

    if (this.selectedMethod == 5)//Linear
    {
      var linearInfo = new UCLinear_LIEBHERR_WornLimitsVM();

      linearInfo.impact_slope = this.LinearImpactSlope;
      linearInfo.impact_intercept = this.LinearImpactIntercept;
      linearInfo.normal_slope = this.LinearNormalSlope;
      linearInfo.normal_intercept = this.LinearNormalIntercept;
      linearInfo.Worn_100 = this._100perceDim
      linearInfo.Starting_Dim = this.startingDim
      linearInfo.toolId = this.selectedTool
      linearInfo.CompartId = this.selectedPart;

      this._limitService.AddNewLinearWornLimit(linearInfo).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully add new worn limit")
        } else {
          this._notification.error("Failed, Unabled to add new worn limit")
        }
      })
    }

    if (this.selectedMethod == 3)//Polynomial
    {
      var PolyInfo = new UCPolynomial_KOMATSU_WornLimitsVM();

       PolyInfo.impact_secondOrder = this.PolynomialImpact2ndOrder;
      PolyInfo.impact_slope = this.PolynomialImpactSlope;
      PolyInfo.impact_intercept=this.PolynomialImpactIntercept;
      PolyInfo.normal_secondOrder = this.PolynomialNormal2ndOrder;
      PolyInfo.normal_intercept=this.PolynomialNormalIntercept;
      PolyInfo.normal_slope=this.PolynomialNormalSlope;

      PolyInfo.Worn_100 = this._100perceDim
      PolyInfo.Starting_Dim = this.startingDim
      PolyInfo.toolId = this.selectedTool
      PolyInfo.CompartId = this.selectedPart;

      this._limitService.AddNewPolynomialWornLimit(PolyInfo).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully add new worn limit")
        } else {
          this._notification.error("Failed, Unabled to add new worn limit")
        }
      })
    }
  }

  UpdateWornLimits() {
    if (this.selectedMethod == 1)//Stepped
    {
      var model = new UCStepped_ITM_WornLimitsVM();
      console.log("stepped", this.Info_SteppedData)
      model.Id = this.Info_SteppedData.Id;
      model.Worn_100 = this._100perceDim
      model.Starting_Dim = this.startingDim
      model.toolId = this.selectedTool
      model.wearDepth_10 = this.Impact10WearDepth
      model.wearDepth_20 = this.Impact20WearDepth
      model.wearDepth_30 = this.Impact30WearDepth
      model.wearDepth_40 = this.Impact40WearDepth
      model.wearDepth_50 = this.Impact50WearDepth
      model.wearDepth_60 = this.Impact60WearDepth
      model.wearDepth_70 = this.Impact70WearDepth
      model.wearDepth_80 = this.Impact80WearDepth
      model.wearDepth_90 = this.Impact90WearDepth
      model.wearDepth_100 = this.Impact100WearDepth
      model.wearDepth_110 = this.Impact110WearDepth
      model.wearDepth_120 = this.Impact120WearDepth
      model.startDepeth_New = this.ImpactStartDepthNew
      model.startDepeth_Mi = this.NormalStartDepthNew
      model.wearDepth_10_Mi = this.Normal10WearDepth
      model.wearDepth_20_Mi = this.Normal20WearDepth
      model.wearDepth_30_Mi = this.Normal30WearDepth
      model.wearDepth_40_Mi = this.Normal40WearDepth
      model.wearDepth_50_Mi = this.Normal50WearDepth
      model.wearDepth_60_Mi = this.Normal60WearDepth
      model.wearDepth_70_Mi = this.Normal70WearDepth
      model.wearDepth_80_Mi = this.Normal80WearDepth
      model.wearDepth_90_Mi = this.Normal90WearDepth
      model.wearDepth_100_Mi = this.Normal100WearDepth
      model.wearDepth_110_Mi = this.Normal110WearDepth
      model.wearDepth_120_Mi = this.Normal120WearDepth
      model.CompartId = this.selectedPart

      this._limitService.UpdateSteppedWornLimit(model).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully update worn limits")
        } else {
          this._notification.error("Failed, Unabled to update worn limits")
        }
      })
    }

    if (this.selectedMethod == 2)//INflection
    {
      var infModel = new UCInflection_CAT_WornLimitsVM();
      infModel.Id = this.Info_InflectionData.Id;
      infModel.mi_Intercept_2 = this.MIYIntercept2
      infModel.hi_Intercept_2 = this.HIYIntercept2
      infModel.mi_Slope_1 = this.MISlope1
      infModel.hi_Slope_1 = this.HISlope1
      infModel.mi_Intercept_1 = this.MIYIntercept1
      infModel.hi_Intercept_1 = this.HIYIntercept1
      infModel.mi_Slope_2 = this.MISlope2
      infModel.hi_Slope_2 = this.HISlope2
      infModel.mi_InflectionPoint = this.MIInflectionPoint
      infModel.hi_InflectionPoint = this.HIInflectionPoint
      infModel.Slope = this.Slope
      infModel.adjust_base = this.AdjustmentToBase
      infModel.Worn_100 = this._100perceDim
      infModel.Starting_Dim = this.startingDim
      infModel.toolId = this.selectedTool
      infModel.CompartId = this.selectedPart;
      this._limitService.UpdateInflectionWornLimit(infModel).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully update worn limits")
        } else {
          this._notification.error("Failed, Unabled to update worn limits")
        }
      })
    }

    if (this.selectedMethod == 5)//Linear
    {
      var linearInfo = new UCLinear_LIEBHERR_WornLimitsVM();
      linearInfo.Id = this.Info_LinearData.Id;
      linearInfo.impact_slope = this.LinearImpactSlope;
      linearInfo.impact_intercept = this.LinearImpactIntercept;
      linearInfo.normal_slope = this.LinearNormalSlope;
      linearInfo.normal_intercept = this.LinearNormalIntercept;

      linearInfo.Worn_100 = this._100perceDim
      linearInfo.Starting_Dim = this.startingDim
      linearInfo.toolId = this.selectedTool
      linearInfo.CompartId = this.selectedPart;
      this._limitService.UpdateLinearWornLimit(linearInfo).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully update worn limits")
        } else {
          this._notification.error("Failed, Unabled to update worn limits")
        }
      })
    }

    if (this.selectedMethod == 3)//Polynomial
    {
      var PolyInfo = new UCPolynomial_KOMATSU_WornLimitsVM();
      PolyInfo.Id = this.Info_PolynomialData.Id;
      PolyInfo.impact_secondOrder = this.PolynomialImpact2ndOrder;
      PolyInfo.impact_slope = this.PolynomialImpactSlope;
      PolyInfo.impact_intercept=this.PolynomialImpactIntercept;
      PolyInfo.normal_secondOrder = this.PolynomialNormal2ndOrder;
      PolyInfo.normal_intercept=this.PolynomialNormalIntercept;
      PolyInfo.normal_slope=this.PolynomialNormalSlope;

      PolyInfo.Worn_100 = this._100perceDim
      PolyInfo.Starting_Dim = this.startingDim
      PolyInfo.toolId = this.selectedTool
      PolyInfo.CompartId = this.selectedPart;
      this._limitService.UpdatePolynomialWornLimit(PolyInfo).subscribe(res => {
        if (res == true) {
          this._notification.success("Sucessfully update worn limits")
        } else {
          this._notification.error("Failed, Unabled to update worn limits")
        }
      })
    }
  }

//<!--CAT -- Or Inflection-->
  ChangeHIInflectionPoint(){
    this.MIInflectionPoint = this.HIInflectionPoint
  }
  ChangeHISlope1(){
    this.MISlope1 =this.HISlope1;
  }
  ChangeHIYIntercept1(){
    this.MIYIntercept1 = this.HIYIntercept1;
  }
  ChangeHISlope2(){
    this.MISlope2 = this.HISlope2;
  }
  ChangeHIYIntercept2(){
    this.MIYIntercept2 = this.HIYIntercept2;
  }

  copyValueTolimitWorn(): void {
    this.NormalStartDepthNew = this.ImpactStartDepthNew;
    this.Normal10WearDepth = this.Impact10WearDepth;
    this.Normal20WearDepth = this.Impact20WearDepth;
    this.Normal30WearDepth = this.Impact30WearDepth;
    this.Normal40WearDepth = this.Impact40WearDepth;
    this.Normal50WearDepth = this.Impact50WearDepth;
    this.Normal60WearDepth = this.Impact60WearDepth;
    this.Normal70WearDepth = this.Impact70WearDepth;
    this.Normal80WearDepth = this.Impact80WearDepth;
    this.Normal90WearDepth = this.Impact90WearDepth;
    this.Normal100WearDepth = this.Impact100WearDepth;
    this.Normal110WearDepth = this.Impact110WearDepth;
    this.Normal120WearDepth = this.Impact120WearDepth;
  }

ValidateNumberInputs(e) {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

  // Allow navigation/editing keys
  if (allowedKeys.includes(e.key)) return true;

  const value = e.target.value;

  // Block leading dot
  if (value.length === 0 && e.key === '.') {
    e.preventDefault();
    return false;
  }

  // Allow one dot if not already present
  if (e.key === '.' && !value.includes('.')) return true;

  // Allow digits 0–9
  if (e.key >= '0' && e.key <= '9') return true;

  // Block everything else
  e.preventDefault();
  return false;
}


}
